import { useParams } from "react-router-dom"

import { DatePresetDigest } from "@costory/types/prisma-client"

import { defaultDigestConfig } from "@costory/shared/utils/digest"

import { QueryWrapper } from "@costory/front/components/layout/QueryWrapper"
import { DigestForm } from "@costory/front/pages/DigestV2/DigestForm"
import {
  useGetDigestConfigQuery,
  useNewDigestMutation,
} from "@costory/front/queries/digest"

export function NewDigest() {
  const mutation = useNewDigestMutation()
  const { period, datePreset } = useParams<{
    period: string
    datePreset: string
  }>()
  const digestConfigQuery = useGetDigestConfigQuery()
  const costColumn = digestConfigQuery.data?.costColumn || "cost"
  const exclusionWhereClause =
    digestConfigQuery.data?.whereClause || defaultDigestConfig.whereClause
  return (
    <QueryWrapper query={digestConfigQuery}>
      {({ data: digestConfig }) => (
        <DigestForm
          initialValues={{
            datePreset: datePreset! as DatePresetDigest,
            period: period!,
          }}
          onSave={(d) => mutation.mutateAsync(d)}
          costColumn={costColumn}
          exclusionWhereClause={exclusionWhereClause}
          isEditMode={false}
          digestConfig={digestConfig}
        />
      )}
    </QueryWrapper>
  )
}
